import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, isInvalid } from 'redux-form'
import { Card, Button } from 'react-bootstrap'
import moment from 'moment'
import * as actions from '../../../actions'
import { FORM_DESABANDONO } from '../../../../../config/forms'
import StatusModal from
  '../../../../Forms/SharedComponents/containers/StatusModal'

class Desabandono1 extends Component {
  render () {
    const {
      onSubmit,
      invalid,
      desabandonoShowSaveModal,
      desabandonoSaveResponse,
      onPrev,
      hideDesabandonoSaveMessageModal,
      iCompletoCpa
    } = this.props

    return (
      <div>
        <StatusModal
          show={desabandonoShowSaveModal}
          onClick={hideDesabandonoSaveMessageModal}
          errorMessage={desabandonoSaveResponse}
          extraErrorMessage={null}
        />
        <h4>Datos de Carta de Porte</h4>
        <br />
        <Card>
          <Card.Body>
            <Card.Title>CPA N° {iCompletoCpa && iCompletoCpa.numero}</Card.Title>
            <Card.Text>
              Fecha de Abandono: {iCompletoCpa && moment(iCompletoCpa.fechaDeAbandono).format('YYYY-MM-DD')}
            </Card.Text>
            <Card.Text>
              Motivo del Abandono: {iCompletoCpa && iCompletoCpa.motivoAbandono}
            </Card.Text>
            <Card.Text>
              Cereal: {iCompletoCpa && iCompletoCpa.cereal}
            </Card.Text>
            <Card.Text>
              Variedad: {iCompletoCpa && iCompletoCpa.cerealVariedad}
            </Card.Text>
            <Card.Text>
              Usuario: {iCompletoCpa && iCompletoCpa.usuarioAbandono}
            </Card.Text>
          </Card.Body>
        </Card>
        <br />

        <Button onClick={() => onPrev()}
          variant='outline-primary'
          size='lg' block
        >Atras</Button>
        <Button
          onClick={() => onSubmit()}
          disabled={invalid}
          variant='outline-primary'
          size='lg' block
        >Confirmar</Button>
      </div>
    )
  };
};

const mapStateToProps = (state) => ({
  invalid: isInvalid(FORM_DESABANDONO)(state),
  desabandonoSaveResponse: state.camionesIngreso.desabandonoSaveResponse,
  desabandonoShowSaveModal: state.camionesIngreso.desabandonoShowSaveModal,
  iCompletoCpa: state.camionesIngreso.iCompletoCpa
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_DESABANDONO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false
})

export default withRedux(withReduxForm(Desabandono1))
